import { GridColDef } from "@mui/x-data-grid";
import CityDetailButton from "./DetailButton";

export const userColumns: GridColDef[] = [
  {
    field: "",
    renderCell: CityDetailButton,
    width: 150,
    headerName: "",
    sortable: false,
    filterable: false,
  },
  {
    field: "id",
    minWidth: 150,
    headerName: "Id",
    sortable: false,
    filterable: false,
  },
  {
    field: "emailConfirmed",
    headerName: "Email Onaylandı",
    flex: 1,
    type: "boolean",
    minWidth: 80,
  },
  {
    field: "accessFailedCount",
    headerName: "Başarısız Girişler",
    flex: 1,
    type: "number",
    minWidth: 80,
  },
  {
    field: "lastModificationTime",
    headerName: "Değiştirilme Tarihi",
    type: "dateTime",
    flex: 1,
    minWidth: 80,
    valueGetter: (v, r) => new Date(v),
  },
  {
    field: "creationTime",
    headerName: "Oluşturulma Tarihi",
    type: "dateTime",
    flex: 1,
    minWidth: 80,
    valueGetter: (v, r) => new Date(v),
  },
];
